import { PrimaryColors } from 'src/types/globalTypes';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import { TmarkChange } from 'src/types/api/trademarkRightsApiTypes';
import { Table, Item, Title, Content } from 'src/components/contents/detail/DetailPage';

interface Iprops {
  data: TmarkChange;
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * 商標移轉紀錄 區塊。
 */
const InfoTmarkChange: React.FC<Iprops> = ({ data, isShow, setIsShow, colorType, noContent }) => {
  const tableColor = colorType.third;
  const angleColor = colorType.fifth;
  const SEPRATOR = ', '; //同格有複數資料的間隔符號

  return (
    <DropdownInfo title={`商標移轉紀錄`} isShow={isShow} setIsShow={setIsShow} color={angleColor}>
      {data.alterations.map((item) => {
        return (
          <Table color={tableColor} key={item.sequence}>
            <Item>
              <Title>移轉序號</Title>
              <Content>{item.sequence || noContent}</Content>
              <Title>移轉公告日期</Title>
              <Content>{item.noticeDate || noContent}</Content>
            </Item>
            <Item>
              <Title>移轉公告卷數</Title>
              <Content>{item.volumnNo || noContent}</Content>
              <Title>移轉公告期數</Title>
              <Content>{item.issueNo || noContent}</Content>
            </Item>
            <Item>
              <Title>受讓人</Title>
              <Content>
                {item.parties.map((party, index) => {
                  index += 1;
                  return index !== item.parties.length ? party.name + SEPRATOR : party.name;
                }) || noContent}
              </Content>
            </Item>
          </Table>
        );
      })}
    </DropdownInfo>
  );
};

export default InfoTmarkChange;
